import React, { useEffect, useState, useContext } from "react";
import axios from "axios";
import {
  cartItemQtyUpdateUrl,
  cartUrl,
  USER_TYPE,
  ACTIVITY_NO_PERMISSION_STATUS_VALUE,
  getActivityNoPermissionStatusLabel,
} from "Utils/constant";
import { formatPrice, getAuthToken } from "Utils/common";
import { AppContext } from "Store";
import Loading from "Components/common/Loading";
import {
  getAllCartItemIds,
  getBundleCartItemIds,
  gotoPdp,
} from "Utils/activityHelper";
import { getSelectedSTObj } from "Utils/addressUtils";
import { Bundle } from "src/types/global";
import defaultProductPic from "Images/default-brand.jpg";
import SCIcon from "Components/common/SCIcon";
import { Checkbox, message } from "antd";
import MCounter from "./MCounter";
import Limitations from "Components/common/Limitation";
import { DownOutlined, UpOutlined } from "@ant-design/icons";

const MBundleSection: React.FC<any> = (props: any) => {
  const { activityId, loadingCart, activityDetail, onBundleQtyChange } = props;
  const [loading, setLoading] = useState<boolean>(true);
  const [firstLoad, setFirstLoad] = useState<boolean>(true);
  const {
    loginState,
    cartData,
    setCartData,
    activityPermissionMeta,
    refreshCart,
    refreshCartData,
    checkedCartItems,
    setCheckedCartItems,
  } = useContext(AppContext);
  const activityNoPermissionLabel = getActivityNoPermissionStatusLabel(
    activityPermissionMeta.activityId === activityId
      ? activityPermissionMeta.customerDataType
      : undefined
  );

  useEffect(() => {
    console.log("MBundleSection rendered");
    if (loginState.status !== "login") return;
    setLoading(true);
    const selectedST = getSelectedSTObj(loginState);
    let cartIds: any[] = [];
    if (activityDetail.activityBasicType === "bundle_promotion") {
      cartIds = getBundleCartItemIds(
        Array.from(checkedCartItems),
        cartData,
        true
      );
    }
    let reqBody = {
      activityId: activityId,
      shipTo: selectedST?.accountNumber,
      selectAll: firstLoad,
      cartIds,
    };
    console.log("refreshCartData reqBody", reqBody);
    axios(cartUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: getAuthToken(),
      },
      data: reqBody,
    })
      .then((res) => {
        const respData = res.data;
        console.log("cart data", respData);
        console.log("firstLoad", firstLoad);
        if (respData.status === "success") {
          setCartData(respData.data);
          const win: any = window;
          if (win.DPCache) {
            win.DPCache.checkedCartIds = null;
          }
          const ids = getAllCartItemIds(
            respData.data,
            activityDetail.activityBasicType
          );
          console.log("ids", ids);
          if (firstLoad) {
            setFirstLoad(false);
            console.log("firstload cartdata");
            setCheckedCartItems(new Set(ids));
          }
          if (respData.data?.status === "bundle_product_changed") {
            onBundleQtyChange && onBundleQtyChange();
          }
        } else if (respData.status === ACTIVITY_NO_PERMISSION_STATUS_VALUE) {
          message.warning(activityNoPermissionLabel);
        }
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  }, [loginState, activityId, refreshCart]);
  const bundleList: any[] = cartData?.activity?.productGroup;

  return (
    <div className="cartWrapper cartBundlesWrapper">
      {(loading || loadingCart) && <Loading overCart={true} />}
      {bundleList?.map((bundleItem: any, index: number) => {
        return (
          <MBundleItem
            checkedCartItems={checkedCartItems}
            setCheckedCartItems={setCheckedCartItems}
            key={bundleItem.tieredRule.id}
            cartData={cartData}
            bundleItem={bundleItem}
            setLoadingCart={setLoading}
            loginState={loginState}
            activityDetail={activityDetail}
            refreshCartData={refreshCartData}
            {...props}
          />
        );
      })}
    </div>
  );
};

const MBundleItem: React.FC<{
  bundle: Bundle;
  loginState: any;
}> = (props: any) => {
  const [resetCount, setResetCount] = React.useState(0);
  const [collapsed, setCollapsed] = React.useState(false);
  const {
    bundleItem,
    loginState,
    checkedCartItems,
    setCheckedCartItems,
    refreshCartData,
    setLoadingCart,
  } = props;
  const isEmployee = loginState?.userType === USER_TYPE.EMPLOYEE;
  const { cartItems, tieredRule } = bundleItem;
  const handleCartItemQtyChange = (newQty: number) => {
    console.log("newQty", newQty);
    if (newQty === bundleItem.bundleQuantity) return;
    setLoadingCart(true);
    axios(cartItemQtyUpdateUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: getAuthToken(),
      },
      data: {
        id: tieredRule.id,
        quantity: newQty,
        activityId: tieredRule.activityId,
      },
    }).then((res) => {
      const respData = res.data;
      if (respData.status === "success") {
        console.log("cart item qty updated");
        refreshCartData();
        return;
      }
      if (respData.status === "inventory_not_enough") {
        message.warning(
          React.createElement(
            "div",
            {
              style: {
                whiteSpace: "pre-line",
              },
            },
            respData.message || "该货号库存不足，暂时无法加入购物车"
          )
        );
        refreshCartData();
        setResetCount((pre) => pre + 1);
        return;
      }
      message.error("更新失败");
      setResetCount((pre) => pre + 1);
      refreshCartData();
    });
  };

  return (
    <div className="cartTabWrapper cartBundleWrapper">
      <div className="headWrapper">
        <span className="checkboxWrapper">
          <Checkbox
            checked={checkedCartItems.has(tieredRule.id)}
            onChange={(e) => {
              console.log("checkbox changed", tieredRule.id, checkedCartItems);
              const checked = e.target.checked;
              if (checked) {
                checkedCartItems.add(tieredRule.id);
                setCheckedCartItems(new Set(checkedCartItems));
              } else {
                checkedCartItems.delete(tieredRule.id);
                setCheckedCartItems(new Set(checkedCartItems));
              }
              refreshCartData();
            }}
          ></Checkbox>
        </span>
        <span
          className="title"
          style={{ paddingLeft: "12px", fontSize: "12px" }}
          dangerouslySetInnerHTML={{
            __html: tieredRule?.tieredName,
          }}
        ></span>
        <span
          style={{ paddingLeft: "12px" }}
          onClick={() => setCollapsed(!collapsed)}
        >
          {collapsed ? <UpOutlined /> : <DownOutlined />}
        </span>
      </div>
      <div className={`collapsableWrapper${collapsed ? " collapsed" : ""}`}>
        <div
          style={{ paddingLeft: "12px", fontSize: "12px" }}
          className={"sectionDesc"}
        >
          {tieredRule?.tieredDescription}
        </div>
        <div className="cartItems">
          {cartItems?.map((cartItem: any) => {
            const { product, activityId } = cartItem;
            if (!product) return null;
            return (
              <div className="cartItemWrapper">
                <div className="imgWrapper">
                  <div className="productImg">
                    <img
                      alt=""
                      src={product.productPic || defaultProductPic}
                      onClick={() => {
                        gotoPdp(product, loginState, "Shopping_Cart", true, 'null', activityId);
                      }}
                    ></img>
                  </div>
                  <div className="shipIconWrapper">
                    {product.deliveryChannel === "SC" && <SCIcon />}
                  </div>
                </div>
                <div className="descWrapper">
                  <div className="line">
                    <span>{product.sku}</span>
                    {product.productSize && (
                      <>
                        <span className="vdivider"></span>
                        <span>{product.productSize}</span>
                      </>
                    )}
                  </div>
                  <div
                    className={product.pdpViewable && !isEmployee ? "line1 linkable" : "line1"}
                    style={{ color: isEmployee ? undefined : "#005daa" }}
                    onClick={() => {
                      console.log("product card clicked");
                      gotoPdp(product, loginState, "Shopping_Cart", true, 'null', activityId);
                    }}
                    dangerouslySetInnerHTML={{ __html: product.productName }}
                  ></div>
                  <div
                    className="priceWrapper"
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      alignItems: "center",
                      gap: "12px",
                    }}
                  >
                    <div>
                      <span className="priceItem lightText lineThrough">
                        {formatPrice(product.listPrice)}
                      </span>
                      <span
                        className="priceItem primaryText"
                        style={{ paddingLeft: "12px" }}
                      >
                        {formatPrice(product.finalPrice || product.promoPrice)}
                      </span>
                    </div>
                    <div>X {product.componentQuantity}</div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        <div className="cartBundleFooter">
          <div>
            <div>
              <span>套装价</span>
              <span
                style={{
                  color: "#e71316",
                  paddingLeft: "4px",
                  fontSize: "16px",
                  fontWeight: "bold",
                }}
              >
                {formatPrice(tieredRule.bundleTotal)}
              </span>
            </div>
          </div>
          <div
            style={{
              fontSize: "12px",
              paddingTop: "4px",
              color: "#e71316",
              flex: "1 1 auto",
              textAlign: "right",
            }}
          >
            <Limitations tieredRule={tieredRule} comma={true} />
          </div>
          <div>
            <MCounter
              product={{
                shoppingQty: bundleItem.bundleQuantity,
                min: tieredRule.minBundle,
                max: tieredRule.maxBundle,
              }}
              bundle={bundleItem}
              login={true}
              type={"bundle"}
              value={bundleItem.bundleQuantity}
              onChange={handleCartItemQtyChange}
              resetCount={resetCount}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default MBundleSection;
